import React from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { Form, Input, Button, Checkbox, Select, Typography, Divider, Card } from 'antd';
import { ReactComponent as LogoIcon } from '../assets/icons/LogoIcon.svg';
import { ReactComponent as WorldIcon } from '../assets/icons/WorldIcon.svg';
import { ReactComponent as GoogleIcon } from '../assets/icons/GoogleIcon.svg';
import './SignIn.css';
import api, { getApiUrl } from '../api';

const { Title, Text } = Typography;
const { Option } = Select;

const SignIn = ({ isModal, onCloseModal }) => {
  const navigate = useNavigate();
  const location = useLocation();

  // Обработка токена из query-параметра после Google OAuth
  React.useEffect(() => {
    const params = new URLSearchParams(location.search);
    const token = params.get('token');
    if (token) {
      localStorage.setItem('token', token);
      navigate('/trade');
    }
  }, [location, navigate]);

  const handleLogin = async (values) => {
    try {
      const response = await api.post('/api/users/login', {
        username: values.email,
        password: values.password,
      });
      localStorage.setItem('token', response.data.token);
      navigate('/trade');
      if (onCloseModal) onCloseModal();
    } catch (error) {
      console.error('Login failed', error);
    }
  };

  return (
    <div className={isModal ? 'sign-in-modal' : 'sign-in-page'} style={isModal ? { position: 'relative', width: 340, minWidth: 280, maxWidth: 380, margin: '0 auto' } : {}}>
      {isModal && (
        <span
          style={{ position: 'absolute', top: 18, right: 18, fontSize: 22, color: '#b8b8d0', cursor: 'pointer', zIndex: 10 }}
          onClick={onCloseModal}
          aria-label="Close"
        >
          ×
        </span>
      )}
      <Card className="login-card" style={isModal ? { width: '100%', minWidth: 0, maxWidth: '100%', boxSizing: 'border-box' } : {}}>
        <Form
          name="login"
          onFinish={handleLogin}
          initialValues={{ remember: true }}
          className="login-form"
          layout="vertical"
        >
          <Form.Item
            name="email"
            label="Email"
            rules={[{ required: true, message: 'Please input your email!' }]}
          >
            <Input placeholder="Enter your email" style={{ '::placeholder': { color: '#e0e0e0' }, color: '#fff', background: '#23223a', border: '1.5px solid #333', fontSize: 16 }} />
          </Form.Item>
          <Form.Item
            name="password"
            label="Password"
            rules={[{ required: true, message: 'Please input your password!' }]}
          >
            <Input.Password placeholder="Enter your password" style={{ '::placeholder': { color: '#e0e0e0' }, color: '#fff', background: '#23223a', border: '1.5px solid #333', fontSize: 16 }} />
          </Form.Item>
          <div className="remember-forgot">
            <Form.Item name="remember" valuePropName="checked" noStyle>
              <Checkbox>Remember me</Checkbox>
            </Form.Item>
            <Link to="/forgot-password" className="forgot-link">Forgot password?</Link>
          </div>
          <Form.Item>
            <Button type="primary" htmlType="submit" className="sign-in-button" block>
              Sign in
            </Button>
          </Form.Item>
          <Divider className="divider">or</Divider>
          <Button
            icon={<GoogleIcon />}
            className="google-button"
            block
            onClick={() => window.location.href = getApiUrl('/api/oauth2/authorize/google')}
          >
            Sign in with Google
          </Button>
          <div className="signup-prompt">
            <span>Don't have an account?</span>
            <Link to="/signup" className="signup-link">Sign up</Link>
          </div>
        </Form>
      </Card>
    </div>
  );
};

export default SignIn; 